import { render, staticRenderFns } from "./MainGame.vue?vue&type=template&id=e3bcd644&scoped=true"
import script from "./MainGame.vue?vue&type=script&lang=ts"
export * from "./MainGame.vue?vue&type=script&lang=ts"
import style0 from "./MainGame.vue?vue&type=style&index=0&id=e3bcd644&prod&lang=less"
import style1 from "./MainGame.vue?vue&type=style&index=1&id=e3bcd644&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bcd644",
  null
  
)

export default component.exports